<template>
    <div class="modal fade in" data-backdrop="static" data-keyboard="false" style="margin-top:150px" id="ModalLoading">
        <div class="modal-dialog modal-sm">
            <div class="card card-primary">
                <div class="card-header">
                    <h3 class="card-title">Carregando</h3>
                </div>
                <div class="card-body">
                    Aguarde enquanto carregamos
                </div>
                <!-- /.card-body -->
                <!-- Loading (remove the following to stop the loading)-->
                <div class="overlay">
                    <i class="fa fa-circle-o-notch fa-spin fa-2x"></i>
                </div>
                <!-- end loading -->
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        methods: {
            open() {
                $('#ModalLoading').modal('toggle');
            },
            close() {
                $('#ModalLoading').modal('toggle');
            }
        }
    }
</script>